import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";

// PODGLĄD DOKUMENTÓW – tak samo jak w Documentation
import JoinDecision from "../components/decision";
import Contract from "../components/contract";
import AdultContract from "../components/adultContract";
import ParentStatement from "../components/parentStatement";
import RulesStatement from "../components/rulesStatement";

export default function Profile() {
  const params = useParams();

  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);

  const [payments, setPayments] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [payError, setPayError] = useState("");

  // ---- 1) Pobierz konta z users2026 i rozbij na subUserów (tak jak w lists) ----
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "users2026"),
      (snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data());
        const clients = [];
        for (let i = 0; i < data.length; i++) {
          const su = data[i]?.subUsers || {};
          for (const v of Object.values(su)) {
            clients.push({ uid: data[i]?.uid, acc: data[i], user: v });
          }
        }
        setUsers(clients);
        setLoadingUsers(false);
      },
      (err) => {
        console.error("Błąd pobierania users2026:", err);
        setUsers([]);
        setLoadingUsers(false);
      }
    );
    return () => unsub();
  }, []);

  // ---- 2) Subuserzy danego rodzica po uid z URL ----
  const subusersOfParent = useMemo(() => {
    if (!params?.uid) return [];
    return (users || []).filter((x) => x?.uid === params.uid);
  }, [users, params?.uid]);

  // Dokument rodzica (z pierwszej pozycji)
  const accountDoc = subusersOfParent?.[0]?.acc;

  // ---- 3) Pobierz ostatnie 3 płatności Stripe po stripeId ----
  useEffect(() => {
    const stripeId =
      accountDoc?.stripeId ||
      accountDoc?.stripeID ||
      accountDoc?.stripe_id ||
      null;

    if (!stripeId) {
      setPayments([]);
      return;
    }

    const FN_URL =
      "https://europe-central2-modit-system.cloudfunctions.net/getUserLatestPayments";

    const load = async () => {
      try {
        setLoadingPayments(true);
        setPayError("");
        const res = await fetch(FN_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ stripeId }),
        });
        if (!res.ok) throw new Error(await res.text());
        const json = await res.json();
        setPayments(Array.isArray(json?.payments) ? json.payments : []);
      } catch (e) {
        console.error("Błąd płatności:", e);
        setPayError("Nie udało się pobrać płatności.");
        setPayments([]);
      } finally {
        setLoadingPayments(false);
      }
    };

    load();
  }, [accountDoc]);

  // ---- helpery UI ----
  const fmtAmount = (amount, currency = "pln") => {
    if (typeof amount !== "number") return "-";
    try {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: currency.toUpperCase(),
      }).format(amount / 100);
    } catch {
      return `${(amount / 100).toFixed(2)} ${currency?.toUpperCase() || ""}`;
    }
  };

  const docLabel = (key, docs) => {
    if (key === "joinRequest") return "Wniosek o dołączenie";
    if (key === "rules") return "Oświadczenie – regulamin";
    if (key === "parentStatement") return "Oświadczenie rodzica";
    if (key === "adultContract") return "Umowa (dorosły)";
    if (key === "contract") {
      const t = docs?.contract?.type;
      return t === "obligation" ? "Umowa (sezon)" : "Umowa";
    }
    return key;
  };

  const pickDownloadUrl = (val) => {
    if (!val || typeof val !== "object") return null;
    return (
      val.file ||
      val.pdf ||
      val.url ||
      val.signedFile ||
      val.documentUrl ||
      val.sign ||
      null
    );
  };

  const copyToClipboard = (str) => {
    const el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    el.focus();
    document.execCommand("copy");
    document.body.removeChild(el);
  };

  const fmtDate = (iso) => {
    try {
      return new Date(iso).toLocaleDateString("pl-PL");
    } catch {
      return "";
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        gap: 24,
        width: "min(1000px, 92%)",
        margin: "20px auto 40px",
      }}
    >
      {/* NAGŁÓWEK */}
      <div style={{ width: "100%" }}>
        <h2 style={{ margin: 0, fontSize: 20, color: "#111" }}>Profil konta</h2>
        <div style={{ color: "#555", fontSize: 13, marginTop: 4 }}>
          UID: {params?.uid}
          {accountDoc?.email ? ` • ${accountDoc?.email}` : ""}
        </div>
      </div>

      {/* PŁATNOŚCI STRIPE */}
      <div
        style={{
          width: "100%",
          border: "1px solid rgba(0,0,0,.12)",
          borderRadius: 10,
          padding: 14,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>Ostatnie płatności</h3>
          <div style={{ fontSize: 12, color: "#666" }}>
            Klient Stripe:{" "}
            {accountDoc?.stripeId ||
              accountDoc?.stripeID ||
              accountDoc?.stripe_id ||
              "—"}
          </div>
        </div>

        {loadingPayments && (
          <div style={{ marginTop: 8, fontSize: 13 }}>Wczytywanie…</div>
        )}
        {payError && (
          <div style={{ marginTop: 8, fontSize: 13, color: "#b91c1c" }}>
            {payError}
          </div>
        )}

        {!loadingPayments && !payError && (
          <>
            {payments?.length === 0 ? (
              <div style={{ marginTop: 8, fontSize: 13, color: "#666" }}>
                Brak danych o płatnościach.
              </div>
            ) : (
              <div style={{ marginTop: 10, overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: 13,
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        textAlign: "left",
                        borderBottom: "1px solid rgba(0,0,0,.1)",
                      }}
                    >
                      <th style={{ padding: "8px 6px" }}>Data</th>
                      <th style={{ padding: "8px 6px" }}>Suma</th>
                      <th style={{ padding: "8px 6px" }}>Status</th>
                      <th style={{ padding: "8px 6px" }}>Podgląd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map((p) => (
                      <tr
                        key={p.id}
                        style={{ borderBottom: "1px dashed rgba(0,0,0,.08)" }}
                      >
                        <td style={{ padding: "8px 6px" }}>
                          {p.issuedAt
                            ? new Date(p.issuedAt).toLocaleString("pl-PL")
                            : "—"}
                        </td>
                        <td style={{ padding: "8px 6px" }}>
                          {fmtAmount(p.amountTotal, p.currency)}
                        </td>
                        <td style={{ padding: "8px 6px" }}>
                          {p.paid ? (
                            <span style={{ color: "#166534", fontWeight: 700 }}>
                              OPŁACONA
                            </span>
                          ) : (
                            <span
                              style={{ color: "#991b1b", fontWeight: 700 }}
                            >
                              {p.status?.toUpperCase() || "NIEOPŁACONA"}
                            </span>
                          )}
                        </td>
                        <td style={{ padding: "8px 6px" }}>
                          {p.hostedInvoiceUrl ? (
                            <a
                              href={p.hostedInvoiceUrl}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                color: "#0045C7",
                                textDecoration: "none",
                                fontWeight: 600,
                              }}
                            >
                              Otwórz fakturę
                            </a>
                          ) : (
                            "—"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>

      {/* LISTA SUBUSERÓW + DOKUMENTY */}
      <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 12 }}>
        <h3 style={{ margin: 0, fontSize: 16, color: "#111" }}>
          Uczestnicy (subUserzy)
        </h3>

        {loadingUsers && <div style={{ fontSize: 13 }}>Wczytywanie…</div>}

        {!loadingUsers && subusersOfParent.length === 0 && (
          <div style={{ fontSize: 13, color: "#666" }}>
            Brak uczestników dla tego konta.
          </div>
        )}

        {!loadingUsers &&
          subusersOfParent.map(({ user }, idx) => {
            const docs = user?.docs || {};
            const required = Array.isArray(docs?.required) ? docs.required : [];

            // Podpisane (zostaje mini-karta z podpisem)
            const signedEntries = Object.entries(docs).filter(
              ([key, val]) =>
                key !== "required" &&
                val &&
                typeof val === "object" &&
                val.signed === true &&
                (!!val.sign || !!val.file || !!val.url || !!val.pdf || !!val.signedFile)
            );

            // Braki
            const missingKeys = required.filter((k) => docs?.[k]?.signed !== true);

            // Dodatkowa lista linków do pobrania poniżej kart
            const downloadable = Object.entries(docs).filter(
              ([key, val]) =>
                key !== "required" &&
                val &&
                typeof val === "object" &&
                val.signed === true &&
                !!pickDownloadUrl(val)
            );

            return (
              <div
                key={user?.index || idx}
                style={{
                  border: "1px solid rgba(0,0,0,.12)",
                  borderRadius: 10,
                  padding: 12,
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ fontSize: 15, fontWeight: 800 }}>
                    {user?.displayName || "—"}
                  </div>
                  <div style={{ fontSize: 12, color: "#555" }}>
                    PESEL: {user?.pesel || "—"} • Data ur.: {user?.dateOfBirth || "—"}
                  </div>
                </div>

                <div style={{ marginTop: 10 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>
                    Dokumenty
                  </div>

                  {/* --- PODPISANE: KARTY Z MINIATURĄ PODPISU (BEZ „POBIERZ”) --- */}
                  {signedEntries.length > 0 ? (
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
                        gap: 10,
                      }}
                    >
                      {signedEntries.map(([key, val]) => (
                        <div
                          key={key}
                          style={{
                            border: "1px solid rgba(0,0,0,.12)",
                            borderRadius: 8,
                            padding: 8,
                            background: "#fff",
                          }}
                        >
                          <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>
                            {docLabel(key, docs)}
                          </div>

                          {val?.sign && (
                            <img
                              src={val.sign}
                              alt="Podpis"
                              style={{
                                width: "100%",
                                height: 110,
                                objectFit: "contain",
                                background: "rgba(0,0,0,0.02)",
                                border: "1px dashed rgba(0,0,0,.15)",
                                borderRadius: 6,
                              }}
                            />
                          )}

                          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
                            <div style={{ fontSize: 11, color: "#666" }}>
                              {val?.date
                                ? `Data: ${fmtDate(val.date)}`
                                : "Data: —"}
                            </div>
                            {/* ZAMIANA: nie pokazujemy przycisku „Pobierz” tutaj */}
                            <span style={{ fontSize: 11, color: "#999" }}>
                              Podpisany
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, color: "#666" }}>
                      Brak podpisanych dokumentów.
                    </div>
                  )}

                  {/* --- PODGLĄD PEŁNYCH DOKUMENTÓW (tak jak w Documentation) --- */}
                  <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12 }}>
                    {/* JoinDecision – jeśli chcesz pokazywać po podpisanej umowie */}
                    {docs?.joinRequest?.signed && (
                      <JoinDecision
                        displayName={user?.displayName}
                        date={fmtDate(docs?.contract?.date)}
                        signing={docs?.contract?.sign}
                      />
                    )}

                    {/* Umowa dla dziecka */}
                    {!user?.adult && docs?.contract?.signed && (
                      <Contract
                        user={user}
                        parent={accountDoc?.parent}
                        acc={accountDoc}
                        date={fmtDate(docs?.contract?.date)}
                        signing={docs?.contract?.sign}
                      />
                    )}

                    {/* Umowa dla dorosłego */}
                    {user?.adult && docs?.adultContract?.signed && (
                      <AdultContract
                        user={user}
                        acc={accountDoc}
                        parent={accountDoc?.parent}
                        date={fmtDate(docs?.adultContract?.date)}
                        signing={docs?.adultContract?.sign}
                      />
                    )}

                    {/* Oświadczenie rodzica (tylko jeśli nie-dorosły) */}
                    {!user?.adult && docs?.parentStatement?.signed && (
                      <ParentStatement
                        user={user}
                        parent={accountDoc?.parent}
                        acc={accountDoc}
                        signing={docs?.parentStatement?.sign}
                        date={fmtDate(docs?.parentStatement?.date)}
                      />
                    )}

                    {/* Regulamin */}
                    {docs?.rules?.signed && (
                      <RulesStatement
                        displayName={user?.displayName}
                        facility={accountDoc?.facility_id}
                        signing={docs?.rules?.sign}
                        date={fmtDate(docs?.rules?.date)}
                      />
                    )}
                  </div>
                </div>

                {/* kopiuj do schowka */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "18px",
                    width: "18px",
                    borderRadius: "5px",
                    backgroundColor: "rgb(0,0,0,0)",
                    padding: "4px",
                    border: "2px solid #0045C7",
                    transition: "0.6s",
                    cursor: "pointer",
                    marginTop: 10,
                  }}
                  onClick={(e) => {
                    e?.stopPropagation();
                    copyToClipboard(
                      (user?.displayName || "") +
                        " - " +
                        (accountDoc?.parent?.phone || "") +
                        " - " +
                        (accountDoc?.uid || "")
                    );
                  }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/clipboard.png"}
                    style={{ width: "25px" }}
                    alt=""
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}
